import React from 'react'
import moment from 'moment';
import styled from 'styled-components'

const CardWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 1rem;

    border-bottom:1px solid #5A5A5A;
`
const Box = styled.div`
`
const Row = styled.div`

    display:flex;
    justify-content: space-between;


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        font-size: 1rem;
        font-family: "Poppins";
        font-weight: 600;
    }


`
const Space = styled.div`
    width: 90px;
`


const CardDataTinyInfoSalle = ({ client, number,data }) => {
    
    const formattedDateTime = moment(data.createdAt).format("DD/MM/YYYY HH:mm:ss");
    const formattedDate = moment(data.createdAt).format("DD/MM/YYYY");
    const plusOneDay = moment(formattedDate, "DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY");
    const plusTenDays = moment(formattedDate, "DD/MM/YYYY").add(10, 'days').format("DD/MM/YYYY");

    return (
        <CardWrapper>
            <Box>
                <BoxText>
                    <p className='textPrimary'>Detalhes da venda</p>
                    <p >Cadastrado em: {formattedDateTime}</p>

                </BoxText>
                <BoxText>
                    <p>Data da venda</p>
                    <p className='textPrimary'>{formattedDate}</p>
                </BoxText>
                <BoxText>
                    <p>Nº pedido</p>
                    <p className='textPrimary'>#{data?.id}</p>
                </BoxText>
                <BoxText>
                    <p>Desconto</p>
                    <p className='textPrimary'>0,00</p>
                </BoxText>
            </Box>
            <Box>
                <BoxText>
                    <p className='textPrimary'></p>
                    <p></p>
                </BoxText>
                <BoxText>
                    <p>Data prevista de entrega</p>
                    <p className='textPrimary'>{data?.type_delivery == "1" ? plusOneDay : plusTenDays}</p>
                </BoxText>
                <BoxText>
                    <p>pedido e-commerce</p>
                    <p className='textPrimary'>#{data?.id}</p>
                </BoxText>
                <BoxText>
                    <p>Frete pago pelo cliente</p>
                    <p className='textPrimary'>R${Number(data?.coust_delivery).toLocaleString("pt-BR",{minimumFractionDigits:2})}</p>
                </BoxText>
            </Box>
            <Space></Space>
            <Box>
                <BoxText>
                    <p className='textPrimary'></p>
                    <p></p>
                </BoxText>
                <BoxText>
                    <p></p>
                    <p className='textPrimary'></p>
                </BoxText>
                <BoxText>
                    <p>Intermediador</p>
                    <p className='textPrimary'>Sem intermediador</p>
                </BoxText>
                <BoxText>
                    <p>Frete pago pela empresa</p>
                    <p className='textPrimary'>R$0,00</p>
                </BoxText>
            </Box>
            <Space></Space>
            <Box>
                <BoxText>
                    <p className='textPrimary'></p>
                    <p></p>
                </BoxText>
                <BoxText>
                    <p></p>
                    <p className='textPrimary'></p>
                </BoxText>
                <BoxText>
                    <p></p>
                    <p className='textPrimary'></p>
                </BoxText>
                <BoxText>
                    <p>Despesas</p>
                    <p className='textPrimary'>R$0,00</p>
                </BoxText>
            </Box>

        </CardWrapper>
    )
}

export default CardDataTinyInfoSalle